import $ from 'jquery'
import 'slick-carousel'
import enquire from 'enquire.js'

export default {
	init() {
		// JavaScript to be fired on the home page
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
		$('.sc_carousel').on('click', '.square_block', function() {
			window.location = $(this).find('a.square_cta').attr('href');
		});

		enquire.register('screen and (max-width: 1023px)', {
			match : function() {
				$('.sc_carousel').slick({
					slide: '.square_block',
					rows: 0, //removes inline-block
					infinite: false,
					slidesToShow: 1,
					centerMode: true,
					variableWidth: true,
					dots: true,
					arrows: false,
				})
			},
			unmatch : function() {
				$('.sc_carousel').slick('unslick');
			},
		});
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js